import { useEffect, useState } from 'react';
import { useDeathStore } from '@/state/deathStore';
import { ui } from './theme';

export function DeathModal() {
  const isDead = useDeathStore((s) => s.isDead);
  const respawnAt = useDeathStore((s) => s.respawnAt);
  const message = useDeathStore((s) => s.message);
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!isDead) return;
    const id = window.setInterval(() => setNow(Date.now()), 100);
    return () => window.clearInterval(id);
  }, [isDead]);

  if (!isDead) return null;
  const secondsLeft = Math.max(0, Math.ceil((respawnAt - now) / 1000));

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        background: 'rgba(0,0,0,0.65)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        pointerEvents: 'auto',
      }}
    >
      <div
        style={{
          ...ui.panel,
          minWidth: 320,
          textAlign: 'center',
          borderColor: '#c0392b',
          border: '2px solid #c0392b',
          padding: 24,
        }}
      >
        <div style={{ fontSize: 28, fontWeight: 800, color: '#e74c3c', marginBottom: 8, letterSpacing: 2 }}>
          YOU DIED
        </div>
        <div style={{ color: '#e8eef7', marginBottom: 16 }}>{message}</div>
        <div style={{ color: '#cfd8dc', fontSize: 14 }}>
          Hồi sinh tại Lorencia sau{' '}
          <span style={{ color: '#ffd166', fontWeight: 700, fontSize: 18 }}>{secondsLeft}s</span>
        </div>
      </div>
    </div>
  );
}
